import { render, staticRenderFns } from "./DraggableList.vue?vue&type=template&id=a6d4629a&scoped=true"
import script from "./DraggableList.vue?vue&type=script&setup=true&lang=ts"
export * from "./DraggableList.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DraggableList.vue?vue&type=style&index=0&id=a6d4629a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6d4629a",
  null
  
)

export default component.exports